import type { ReactNode } from "react";
import HelpTip from "../../common/HelpTip";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

type Props = {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  valueClassName?: string;
  tooltip?: string;
};

const PkStatTile = ({ label, value, sub, valueClassName, tooltip }: Props) => (
  <div className="pk-card">
    <div className="epic-lb-card-title">
      {label}
      {tooltip && <HelpTip text={tooltip} />}
    </div>
    <div className={valueClassName ?? "pk-tile-value"}>{value}</div>
    {sub && <div className="epic-lb-muted">{sub}</div>}
  </div>
);

export const formatRatio = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : value.toFixed(2);

export default PkStatTile;
